import * as React from "react";

import { Root } from "./Italic.styles";

interface ItalicProps {
    children: React.ReactNode;
}

export class Italic extends React.Component<ItalicProps> {
    public render(): JSX.Element {
        return <Root>{this.props.children}</Root>;
    }
}
